import { useEffect, useRef } from 'react';
import { useDialogues } from '../Dialogues';
import { useSession } from '.';
import { usePreference } from '../../Data/Preference';
import { redesignWelcomeDialogueOptions } from './RedesignWelcomeDialogue';

const RedesignAnnouncements = () => {
    const { info } = useDialogues();
    const {
        redesignMigrationWelcomePending,
        clearRedesignMigrationWelcomePending,
        setShowRedesign,
    } = useSession();
    const [, setRedesignMigrationWelcomeHandled] = usePreference(
        'experimental:redesignMigrationWelcomeHandled',
        false,
        false,
        false,
    );
    const firedRef = useRef(false);

    useEffect(() => {
        if (!redesignMigrationWelcomePending) {
            firedRef.current = false;
        }
    }, [redesignMigrationWelcomePending]);

    useEffect(() => {
        if (!redesignMigrationWelcomePending) {
            return;
        }
        if (firedRef.current) {
            return;
        }
        firedRef.current = true;

        setRedesignMigrationWelcomeHandled(true);

        clearRedesignMigrationWelcomePending();

        info(redesignWelcomeDialogueOptions('migrated'));
        setShowRedesign(true);
    }, [
        redesignMigrationWelcomePending,
        info,
        clearRedesignMigrationWelcomePending,
        setShowRedesign,
        setRedesignMigrationWelcomeHandled,
    ]);

    return null;
};

export default RedesignAnnouncements;
